<template>
    <div>
        <Header/>
        <PageTitle
                title="Связь с нами - очень легко!"
                subtitle="Мы всегда рады вас слышать!"
        >
        </PageTitle>
        <section class="section">
            <div class="container">
                <div class="columns">
                    <div class="column is-4">
                        Наши магазины:
                        <hr/>
                        <span class="tag is-small is-warning">Магазин Б32, Торговые ряды Малика</span><br/>
                        <span class="tag is-small is-warning">Магазин А29, Торговые ряды Малика</span><br/>
                        <span class="tag is-small is-warning">Магазин А26, Торговые ряды Малика</span><br/>
                        <span class="tag is-small is-warning">Магазин Б6, Торговые ряды Малика</span><br/>
                    </div>
                    <div class="column">
                        Наши телефоны:
                        <hr/>
                        <span class="tag is-small is-warning"><a href="tel:+998981285872">+998 98 128 58 72</a></span>
                        <span class="tag is-small is-warning"><a href="tel:+998997950471">+998 99 795 04 71</a></span>
                        <span class="tag is-small is-warning"><a href="tel:+998997950472">+998 99 795 04 72</a></span>
                        <span class="tag is-small is-warning"><a href="tel:+998997950473">+998 99 795 04 73</a></span>
                        <span class="tag is-small is-warning"><a href="tel:+998997950475">+998 99 795 04 75</a></span>
                        <span class="tag is-small is-warning"><a href="tel:+998997950476">+998 99 795 04 76</a></span>
                        <span class="tag is-small is-warning"><a href="tel:+998909556057">+998 90 955 60 57</a></span>
                    </div>
                </div>
            </div>
        </section>
        <div class="container">
            <div class="columns">
                <div class="column is-4 is-pulled-right">
                    <div class="fb-page" data-href="https://www.facebook.com/ultrashoptashkent"
                         data-tabs="timeline, events, messages" data-width="390" data-small-header="true"
                         data-adapt-container-width="false" data-hide-cover="true" data-show-facepile="true">
                        <blockquote cite="https://www.facebook.com/ultrashoptashkent" class="fb-xfbml-parse-ignore"><a
                                href="https://www.facebook.com/ultrashoptashkent">UltraShop - Ультрабуки/Ноутбуки</a>
                        </blockquote>
                    </div>
                </div>
                <div class="column">
                    <iframe class="is-pulled-right"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2995.649060597911!2d69.26857451542428!3d41.338243979268775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xbae48ec334cd5f32!2zVWx0cmFTaG9wLnV6IC0g0JzQsNCz0LDQt9C40L0g0L3QvtGD0YLQsdGD0LrQvtCyINCyINCi0LDRiNC60LXQvdGC0LU!5e0!3m2!1sen!2s!4v1539033204636"
                            width="900" height="600"
                            frameborder="0"
                            style="border:0"
                            allowfullscreen>
                    </iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TopBar from "../../components/header/TopBar";
    import Header from "../../components/header/Header";
    import PageTitle from "../../components/elements/PageTitle";

    export default {
        name: "Contacts",
        components: {PageTitle, Header, TopBar},
        created() {
            (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.1&appId=2084346911791519&autoLogAppEvents=1';
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'))
        }
    }
</script>

<style scoped>
</style>